export default {"src":"/_next/static/media/network.7cb3101f.svg","height":52,"width":52};